/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CalculateHealthMetricsRequest } from '../model';
// @ts-ignore
import { CalculateHealthMetricsResponse } from '../model';
/**
 * AdminHealthMetricsControllerApi - axios parameter creator
 * @export
 */
export const AdminHealthMetricsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CalculateHealthMetricsRequest} calculateHealthMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateHealthMetrics: async (calculateHealthMetricsRequest: CalculateHealthMetricsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateHealthMetricsRequest' is not null or undefined
            assertParamExists('calculateHealthMetrics', 'calculateHealthMetricsRequest', calculateHealthMetricsRequest)
            const localVarPath = `/admin/health-metrics/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateHealthMetricsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminHealthMetricsControllerApi - functional programming interface
 * @export
 */
export const AdminHealthMetricsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminHealthMetricsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CalculateHealthMetricsRequest} calculateHealthMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateHealthMetrics(calculateHealthMetricsRequest: CalculateHealthMetricsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateHealthMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateHealthMetrics(calculateHealthMetricsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminHealthMetricsControllerApi - factory interface
 * @export
 */
export const AdminHealthMetricsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminHealthMetricsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CalculateHealthMetricsRequest} calculateHealthMetricsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateHealthMetrics(calculateHealthMetricsRequest: CalculateHealthMetricsRequest, options?: any): AxiosPromise<CalculateHealthMetricsResponse> {
            return localVarFp.calculateHealthMetrics(calculateHealthMetricsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminHealthMetricsControllerApi - object-oriented interface
 * @export
 * @class AdminHealthMetricsControllerApi
 * @extends {BaseAPI}
 */
export class AdminHealthMetricsControllerApi extends BaseAPI {
    /**
     * 
     * @param {CalculateHealthMetricsRequest} calculateHealthMetricsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminHealthMetricsControllerApi
     */
    public calculateHealthMetrics(calculateHealthMetricsRequest: CalculateHealthMetricsRequest, options?: AxiosRequestConfig) {
        return AdminHealthMetricsControllerApiFp(this.configuration).calculateHealthMetrics(calculateHealthMetricsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

